// Texts of the ERP areas "Financeiro", "RH", "Painel", "Relatórios" and "Chamados" (pt-BR).
export default {
  finance: {
    title: 'Financeiro',
    subtitle: 'Lançamentos, pagamentos e recebimentos, contas e o fluxo de caixa.',
    tabs: { entries: 'Lançamentos', statement: 'Extrato', cards: 'Cartões' },
    newEntry: 'Novo lançamento',
    newAccount: 'Nova conta',
    newCategory: 'Nova categoria',
    noCategory: 'Sem categoria',
    newCategoryOption: '+ Nova categoria…',
    hideValues: 'Ocultar valores',
    showValues: 'Mostrar valores',
    hidden: '•••••',
    cashFlow: {
      title: 'Fluxo de caixa previsto',
      months: 'Período',
      monthsOption: '{n} meses',
      opening: 'Saldo no início do mês: {value}',
      overdue: 'Vencidos ainda em aberto entram no primeiro mês: a receber {income}, a pagar {expense}.',
      horizon: 'Recorrências sem fim aparecem até {date} (o sistema estende sozinho).',
      columns: { month: 'Mês', income: 'Entradas', expense: 'Saídas', net: 'Saldo do mês', cumulative: 'Saldo acumulado' },
    },
    filters: {
      type: 'Tipo',
      status: 'Situação',
      dateBase: 'Data',
      from: 'De',
      to: 'Até',
      account: 'Conta',
      category: 'Categoria',
      review: 'Conferência',
      searchPlaceholder: 'Descrição ou observação',
    },
    dateBase: { due: 'Vencimento', occurrence: 'Ocorrência', competence: 'Competência', settlement: 'Pagamento/recebimento' },
    statusFilter: {
      all_but_cancelled: 'Todas (menos canceladas)',
      pending: 'Em aberto e parciais',
      open: 'Em aberto',
      partial: 'Parciais',
      settled: 'Liquidadas',
      overdue: 'Vencidas',
      cancelled: 'Canceladas',
      all: 'Todas',
    },
    reviewFilter: { any: 'Todas', reviewed: 'Conferidos', notReviewed: 'Não conferidos', needsReview: 'A revisar (migração)' },
    totalsCount: '{n} lançamento | {n} lançamentos',
    totalsIncome: 'Receitas',
    totalsExpense: 'Despesas',
    totalsSettled: 'Liquidado',
    totalsOpen: 'Em aberto',
    columns: {
      select: 'Selecionar',
      type: 'Tipo',
      category: 'Categoria',
      description: 'Descrição',
      party: 'Cliente/fornecedor',
      project: 'Projeto',
      account: 'Conta',
      occurrenceDate: 'Ocorrência',
      competenceDate: 'Competência',
      dueDate: 'Vencimento',
      lastSettlementDate: 'Pago/recebido em',
      status: 'Situação',
      reviewed: 'Conferido',
      amount: 'Valor',
      openAmount: 'Em aberto',
    },
    type: { income: 'Receita', expense: 'Despesa' },
    status: { open: 'Em aberto', partially_settled: 'Parcial', settled: 'Liquidado', cancelled: 'Cancelado' },
    settledLabel: { income: 'Recebido', expense: 'Pago' },
    overdue: 'Vencido',
    reviewed: 'Conferido',
    reviewedShort: 'conferido',
    openShort: '{value} em aberto',
    needsReview: 'Revisar',
    costType: { fixed: 'Fixo', variable: 'Variável' },
    noCostType: 'Não informado',
    origin: { manual: 'Manual', proposal: 'Proposta', credit_card: 'Cartão', integration: 'Integração' },
    emptyTitle: 'Nenhum lançamento',
    emptyText: 'Lance as receitas e despesas para acompanhar o caixa.',
    dialogNew: 'Novo lançamento',
    dialogEdit: 'Lançamento',
    fields: {
      type: 'Tipo',
      category: 'Categoria',
      costType: 'Custo',
      description: 'Descrição',
      customer: 'Cliente',
      supplier: 'Fornecedor',
      project: 'Projeto',
      account: 'Conta prevista',
      amount: 'Valor',
      occurrenceDate: 'Data da ocorrência',
      competenceDate: 'Competência',
      competenceHint: 'Vazio: o mês da ocorrência.',
      dueDate: 'Vencimento',
      notes: 'Observações',
      alreadySettled: { income: 'Já recebido', expense: 'Já pago' },
      settleAccount: 'Conta',
      settleDate: 'Data',
    },
    noAccount: 'Sem conta prevista',
    noSupplier: 'Nenhum',
    newAccountOption: '+ Nova conta…',
    amountRequired: 'Informe um valor maior que zero.',
    reviewNote: 'Revisar: {note}',
    reviewResetNote: 'Conferência retirada em {date}: {reason}',
    detail: {
      settled: 'Liquidado',
      open: 'Em aberto',
      settlements: 'Pagamentos e recebimentos',
      data: 'Dados do lançamento',
      more: 'Mais detalhes',
      breakdown: '{principal} + juros/multa/desconto {extra}',
      noSettlements: 'Nenhum pagamento ou recebimento registrado.',
      settle: { income: 'Registrar recebimento', expense: 'Registrar pagamento' },
      reverse: 'Estornar',
      reversed: 'Estornado em {date}',
      by: 'por {name}',
      review: 'Marcar como conferido',
      unreview: 'Desmarcar conferido',
      reviewedBy: 'Conferido por {name} em {date}',
      cancel: 'Cancelar lançamento',
      cancelled: 'Cancelado em {date}',
      origin: 'Origem: {origin}',
      created: 'Criado em {date}',
    },
    settle: {
      title: { income: 'Registrar recebimento', expense: 'Registrar pagamento' },
      account: 'Conta',
      date: 'Data efetiva',
      amount: 'Valor (principal)',
      interest: 'Juros',
      fine: 'Multa',
      discount: 'Desconto',
      notes: 'Observação',
      openAmount: 'Em aberto: {value}',
      cash: 'Movimenta a conta em {value}',
      save: 'Registrar',
      saved: 'Registrado.',
    },
    cancel: {
      entryTitle: 'Cancelar este lançamento?',
      entryText: 'Ele sai dos saldos e da previsão, mas fica no histórico.',
      contractEntryText: 'Esta conta é do contrato {code}. Ao cancelar, ela continua no contrato como "Sem cobrança", com o motivo que você escrever. Os outros meses do contrato não mudam.',
      settlementTitle: 'Estornar este pagamento/recebimento?',
      settlementText: 'O valor sai do saldo da conta e volta a ficar em aberto. O registro fica no histórico.',
      transferTitle: 'Cancelar esta transferência?',
      transferText: 'Ela sai do saldo das duas contas e fica no histórico.',
      reason: 'Motivo (opcional)',
      confirm: 'Confirmar',
    },
    deleteContractEntryText: 'Esta conta é do contrato {code}. Ela não será apagada: continua no contrato como "Sem cobrança" (com o histórico), some dos saldos e da previsão, e os próximos meses não mudam.',
    deleteEntryText:'O lançamento será excluído. Só é possível em lançamentos manuais que nunca tiveram pagamento.',
    batch: {
      selected: '{n} selecionado | {n} selecionados',
      selectPage: 'Selecionar a página',
      allFiltered: 'Aplicar a todos os {n} resultados filtrados',
      clear: 'Limpar seleção',
      action: 'Ação em lote',
      category: 'Trocar categoria',
      cost_type: 'Trocar custo (fixo/variável)',
      review: 'Marcar como conferidos',
      unreview: 'Desmarcar conferidos',
      cancel: 'Cancelar',
      apply: 'Aplicar',
      done: '{n} lançamento alterado. | {n} lançamentos alterados.',
      confirmTitle: 'Aplicar a {n} lançamentos?',
      confirmText: 'Tudo ou nada: se algum não puder ser alterado, nenhum é.',
    },
    statement: {
      account: 'Conta',
      from: 'De',
      to: 'Até',
      previous: 'Saldo anterior',
      inflows: 'Entradas',
      outflows: 'Saídas',
      closing: 'Saldo final',
      empty: 'Nenhuma movimentação no período.',
      pick: 'Escolha uma conta bancária ou caixa.',
      beforeOpening: '{n} movimentação é anterior à data do saldo inicial e não entra no saldo: confira a conta. | {n} movimentações são anteriores à data do saldo inicial e não entram no saldo: confira a conta.',
      columns: { date: 'Data', description: 'Descrição', category: 'Categoria', inflow: 'Entrada', outflow: 'Saída', balance: 'Saldo' },
      kind: { settlement: '', transfer_in: 'Transferência de {account}', transfer_out: 'Transferência para {account}' },
      openingLine: 'Saldo inicial em {date}',
    },
    add: {
      overline: 'Novo lançamento',
      title: 'Adicionar transação',
      kind: { expense: 'Despesa', income: 'Receita', transfer: 'Transferência' },
      date: 'Data',
      account: 'Conta/cartão',
      from: 'Conta de origem',
      to: 'Conta de destino',
      descriptionPlaceholder: 'Ex.: Supermercado',
      costType: 'Natureza do custo',
      cost: { fixed: 'Custo fixo', variable: 'Custo variável' },
      status: 'Status',
      review: { pending: 'Pendente de conferência', reviewed: 'Conferido' },
      invoiceDue: 'Fatura / vencimento',
      invoiceDueHint: 'A despesa será exibida neste vencimento; a data da compra continuará registrada nos detalhes.',
      more: 'Mais opções',
      onCard: 'Compra no cartão de crédito',
      toTransfer: 'Transferência entre contas',
      repeatTitle: 'Repetir lançamento',
      repeatSub: 'Escolha como este lançamento deve se repetir',
      repeat: { none: 'Sem repetição', monthly: 'Parcelamento mensal', advanced: 'Avançado' },
      startAtInstallment: 'Iniciar na parcela',
      totalInstallments: 'Total de parcelas',
      of: 'de',
      perInstallment: 'Valor por parcela',
      monthlySummary: '{n} parcela será criada, a {from}ª. | {n} parcelas serão criadas, da {from}ª até a {to}ª.',
      every: 'Repetir a cada',
      periodLabel: 'Período',
      period: { monthly: 'Mês', yearly: 'Ano' },
      everyText: { monthly: 'todo mês | a cada {n} meses', yearly: 'todo ano | a cada {n} anos' },
      indefinite: 'Repetir indefinidamente',
      startAtOccurrence: 'Iniciar na ocorrência',
      occurrences: 'Número de ocorrências',
      perOccurrence: 'Valor por ocorrência',
      advancedSummary: 'Repete {every}, da {from}ª até a {to}ª ocorrência.',
      advancedEndless: 'Repete {every}, a partir da {from}ª ocorrência, sem fim.',
      note: 'Nota',
      notePlaceholder: 'Informações adicionais sobre o lançamento',
      add: 'Adicionar lançamento',
    },
    repeat: {
      label: 'Como é',
      once: 'Única',
      recurring: 'Recorrente',
      installments: 'Parcelada',
      card: 'No cartão',
      recurringHint: 'O valor é de cada ocorrência: R$ 2.000,00 por mês durante 12 meses são 12 lançamentos de R$ 2.000,00. Cada um tem sua situação e seus pagamentos.',
      installmentsHint: 'O valor é o total a dividir: R$ 2.000,00 em 12 parcelas somam R$ 2.000,00. A divisão é em centavos; as primeiras levam o centavo que sobrar.',
      cardHint: 'A compra não sai do banco agora: entra nas faturas do cartão. O que sai do banco é o pagamento da fatura.',
      amountPer: 'Valor por ocorrência',
      amountTotal: 'Valor total',
      periodicity: 'Periodicidade',
      periodicityOption: { monthly: 'Mensal', yearly: 'Anual' },
      firstDueDate: 'Primeiro vencimento',
      count: 'Quantas vezes',
      countHint: 'Inclui a primeira. Vazio: sem fim (gera 12 meses à frente).',
      competenceRule: 'Competência',
      competenceOption: { due_month: 'Mês do vencimento', previous_month: 'Mês anterior ao vencimento' },
      installmentCount: 'Número de parcelas',
      purchaseDate: 'Data da compra',
      cardAccount: 'Cartão',
      firstInvoice: 'Primeira fatura',
      firstInvoiceAuto: 'Pela data da compra',
      firstInvoiceHint: 'Corrija se o banco lançou em outra fatura.',
      preview: 'Prévia',
      previewNumber: 'Parcela',
      previewInvoice: 'Fatura',
      previewInvoiceValue: '{month} (vence {due})',
      noCards: 'Cadastre um cartão em Cadastros › Contas financeiras (com fechamento e vencimento).',
    },
    contract: {
      notice: 'Conta do contrato {code} · {title}. Editar vale só para esta conta e o contrato registra a alteração; cancelar ou excluir deixa o mês como "Sem cobrança" no contrato.',
      open: 'Abrir o contrato',
    },
    series: {
      title: 'Recorrência',
      occurrence: 'Ocorrência {n} de {total}',
      occurrenceOpen: 'Ocorrência {n} (sem fim)',
      open: 'Ver recorrência',
      rule: 'Regra atual',
      every: '{amount} · {periodicity} · dia {day}',
      count: '{n} ocorrências',
      endless: 'Sem fim (geradas até {date})',
      ended: 'Encerrada em {date}',
      versions: 'Histórico da regra',
      versionFrom: 'A partir da ocorrência {n}',
      occurrences: 'Ocorrências',
      exception: 'editada só ela',
      cancelFrom: 'Cancelar desta em diante',
      scopeTitle: 'Alterar a recorrência',
      scopeText: 'Este lançamento faz parte de uma recorrência. O que você quer alterar?',
      scopeOnly: 'Somente esta',
      scopeOnlyHint: 'Só este lançamento muda; a regra continua igual.',
      scopeNext: 'Esta e as próximas',
      scopeNextHint: 'A regra muda a partir desta ocorrência. Pagas, parcialmente pagas e editadas só elas não mudam.',
      previewTitle: 'Confirmar a alteração',
      previewChanged: '{n} ocorrência será alterada. | {n} ocorrências serão alteradas.',
      previewSettled: 'Não mudam (já têm pagamento): {list}.',
      previewExceptions: 'Não mudam (editadas só elas): {list}.',
      previewUnreview: '{n} perde a conferência. | {n} perdem a conferência.',
      cancelScopeTitle: 'Cancelar',
      cancelOnly: 'Somente esta',
      cancelNext: 'Esta e as próximas (encerra a recorrência)',
      cancelPreview: 'Serão canceladas: {list}.',
      cancelBlocked: 'Já têm pagamento e impedem o cancelamento: {list}. Estorne o pagamento ou cancele a partir de uma ocorrência posterior.',
      apply: 'Aplicar',
    },
    plan: {
      title: 'Parcelamento',
      installment: 'Parcela {n}/{total}',
      open: 'Ver parcelamento',
      originalTotal: 'Total contratado',
      currentTotal: 'Total vigente',
      settled: 'Liquidado',
      remaining: 'Saldo restante',
      cancelled: 'Cancelado',
      credits: 'Estornos',
      installments: 'Parcelas',
      redistribute: 'Manter o total contratado',
      redistributeTitle: 'Redistribuir as parcelas em aberto?',
      redistributeText: 'As parcelas em aberto passam a somar o total contratado ({total}). Parcelas pagas não mudam.',
      cancelFrom: 'Cancelar desta parcela em diante',
      cancelPreview: 'Serão canceladas as parcelas {list} ({amount}).',
      scopeTitle: 'Alterar o parcelamento',
      scopeText: 'Descrição, categoria e custo podem mudar só nesta parcela ou nesta e nas próximas (o total não muda). Mudar o valor de uma parcela muda o total vigente.',
      scopeOnly: 'Somente esta parcela',
      scopeNext: 'Esta e as próximas',
    },
    cards: {
      receivable: 'A receber',
      payable: 'A pagar',
      overdue: '{value} vencido',
      currentBalance: 'Saldo das contas hoje',
      projectedBalance: 'Saldo previsto',
      projectedHint: 'Saldo de hoje + a receber − a pagar',
      empty: 'Nenhum cartão cadastrado.',
      emptyText: 'Cadastre o cartão em Cadastros › Contas financeiras, com o dia do fechamento e do vencimento.',
      limit: 'Limite',
      committed: 'Comprometido',
      available: 'Disponível',
      committedHint: 'Inclui as parcelas futuras ainda não pagas.',
      currentInvoice: 'Fatura atual',
      days: 'Fecha dia {closing} · vence dia {due}',
      invoices: 'Faturas',
      noInvoices: 'Nenhuma fatura ainda.',
      columns: { month: 'Fatura', closing: 'Fechamento', due: 'Vencimento', total: 'Total', paid: 'Pago', open: 'A pagar', status: 'Situação' },
      status: { open: 'Aberta', closed: 'Fechada', partially_paid: 'Paga em parte', paid: 'Paga', empty: 'Vazia' },
      invoiceTitle: 'Fatura {card} · {month}',
      items: 'Lançamentos da fatura',
      charges: 'Compras',
      credits: 'Estornos',
      total: 'Total',
      paid: 'Pago',
      openAmount: 'A pagar',
      payments: 'Pagamentos',
      noPayments: 'Nenhum pagamento.',
      pay: 'Pagar fatura',
      payTitle: 'Pagar a fatura',
      payAccount: 'Conta que pagou',
      payDate: 'Data do pagamento',
      payAmount: 'Valor pago',
      payHint: 'Sai da conta escolhida. Não é uma nova despesa: as despesas são as compras.',
      paySaved: 'Pagamento registrado.',
      cancelPayment: 'Cancelar pagamento',
      cancelPaymentTitle: 'Cancelar este pagamento?',
      cancelPaymentText: 'O valor volta para a conta e a fatura volta a ter esse valor a pagar. O registro fica no histórico.',
      refund: 'Estorno',
      refundTitle: 'Estorno de compra',
      refundAmount: 'Valor creditado',
      refundDate: 'Data do estorno',
      refundInvoice: 'Fatura em que o crédito entrou',
      refundCancelFuture: 'O banco cancelou as próximas parcelas desta compra',
      refundHint: 'Registre o que aconteceu de verdade na fatura: o crédito entra na fatura escolhida; a compra e os pagamentos continuam no histórico.',
      move: 'Trocar de fatura',
      moveTitle: 'Trocar a parcela de fatura',
      moveMonth: 'Mês da fatura',
      credit: 'Estorno',
      cardItem: 'Cartão {card}',
      cardItemHint: 'Compra no cartão: é paga pela fatura, não individualmente.',
      viewInvoice: 'Ver fatura',
    },
    transfer: {
      dialogNew: 'Transferência entre contas',
      dialogEdit: 'Transferência',
      from: 'De (origem)',
      to: 'Para (destino)',
      amount: 'Valor',
      date: 'Data',
      description: 'Descrição',
      hint: 'Sai de uma conta e entra na outra na mesma data. Não é receita nem despesa. Data futura = agendada (não mexe no saldo até o dia).',
      fee: 'Tarifa (opcional)',
      feeCategory: 'Categoria da tarifa',
      feeHint: 'A tarifa é uma despesa à parte, paga pela conta de origem. O destino recebe o valor cheio.',
      scheduled: 'Agendada',
      cancel: 'Cancelar transferência',
      list: 'Transferências do período',
    },
    classification: {
      looking: 'Procurando a categoria…',
      automatic: 'Sugestão automática: {reason}',
      suggested: 'Sugestão automática: {path} ({reason})',
      none: 'Nenhuma regra para esta descrição: escolha a categoria ou deixe sem categoria.',
      use: 'Usar sugestão automática',
      learnTitle: 'Lembrar esta classificação?',
      learnText: 'Os próximos lançamentos com a descrição "{description}" vão para "{path}".',
      learnHint: 'Só vale para a mesma descrição (sem diferença de maiúsculas, acentos ou pontuação). Os lançamentos anteriores não mudam.',
      remember: 'Lembrar',
      notNow: 'Agora não',
      conflictText: 'Esta descrição já está guardada para "{path}". Atualizar a regra muda só os próximos lançamentos.',
      onlyThis: 'Só este lançamento',
      updateRule: 'Atualizar a regra',
      learned: { created: 'Classificação lembrada.', updated: 'Regra atualizada.', unchanged: 'Essa classificação já estava guardada.' },
      learnedText: 'Os próximos lançamentos com esta descrição vão para "{path}".',
      applyHint: 'Quer aplicar também aos lançamentos anteriores com a mesma descrição? Antes, você vê a prévia.',
      applyPrevious: 'Aplicar aos lançamentos anteriores',
      done: 'Concluir',
      applyTitle: 'Aplicar aos lançamentos anteriores',
      from: 'Competência de',
      to: 'Até',
      onlyUncategorized: 'Só os lançamentos sem categoria',
      previewCount: 'Nenhum lançamento muda. | 1 lançamento muda de categoria. | {n} lançamentos mudam de categoria.',
      currentCategory: 'Categoria',
      sampleOf: 'Mostrando {shown} de {n}.',
      applyButton: 'Aplicar | Aplicar a 1 lançamento | Aplicar a {n} lançamentos',
      applyConfirmTitle: 'Mudar a categoria destes lançamentos?',
      applyConfirmText: 'Só a categoria muda. Valores, datas, contas e situação continuam iguais.',
      applied: 'Nenhum lançamento mudou. | 1 lançamento classificado. | {n} lançamentos classificados.',
      queue: '1 lançamento sem categoria. | {n} lançamentos sem categoria.',
      queueShow: 'Ver e classificar',
    },
    rules: {
      title: 'Regras de classificação',
      subtitle: 'Como o sistema sugere a categoria dos lançamentos. A escolha feita por você sempre vale mais.',
      new: 'Nova regra',
      dialogNew: 'Nova regra',
      dialogEdit: 'Editar regra',
      version: 'Versão {n}',
      searchPlaceholder: 'Texto, categoria ou fornecedor',
      empty: 'Nenhuma regra encontrada',
      simulator: 'Testar regras',
      simulatorPlaceholder: 'Digite uma descrição para ver a categoria sugerida',
      normalized: 'Texto comparado: {text}',
      priorityShort: 'prioridade {n}',
      conflict: 'Conflito',
      conflicts: '1 regra em conflito: o mesmo texto indica categorias diferentes. | {n} regras em conflito: o mesmo texto indica categorias diferentes.',
      recentUses: 'Usos recentes',
      noUses: 'Esta regra ainda não classificou nenhum lançamento.',
      activate: 'Ativar',
      inactivate: 'Inativar',
      chooseCategory: 'Escolha a categoria',
      priorityHint: 'De 0 a 100. Maior vence; use só para exceções.',
      status: { active: 'Ativa', inactive: 'Inativa' },
      columns: {
        rule: 'Regra',
        mode: 'Como compara',
        category: 'Categoria',
        type: 'Natureza',
        priority: 'Prioridade',
        origin: 'Origem',
        uses: 'Usos',
        lastUsed: 'Último uso',
        status: 'Situação',
      },
      fields: {
        type: 'Natureza',
        mode: 'Como compara',
        description: 'Descrição',
        phrase: 'Texto',
        priority: 'Prioridade',
        active: 'Regra ativa',
        notes: 'Observações',
      },
      mode: {
        exact_description: 'Descrição igual',
        conditions: 'Fornecedor/cliente + texto',
        counterparty: 'Fornecedor/cliente',
        phrase: 'Contém o texto',
        prefix: 'Começa com',
      },
      modeHint: {
        exact_description: 'A descrição inteira igual (sem diferença de maiúsculas, acentos ou pontuação).',
        conditions: 'O fornecedor (despesa) ou o cliente (receita) e o texto na descrição.',
        counterparty: 'Todo lançamento deste fornecedor (despesa) ou cliente (receita).',
        phrase: 'As palavras inteiras na descrição: "gás" não acha "gastos". Termos genéricos sozinhos (taxa, pix, Amazon...) não são aceitos.',
        prefix: 'A descrição começa com estas palavras inteiras.',
      },
      origin: { default: 'Padrão', manual: 'Manual', learned: 'Aprendida', imported: 'Importada' },
      outcome: {
        explicit: 'Escolhida por você',
        origin: 'Definida pela origem',
        identified: 'Identificada',
        ambiguous: 'Ambígua',
        not_identified: 'Sem categoria',
        not_eligible: 'Não se aplica',
      },
    },
    categories: {
      emptyTitle: 'Nenhuma categoria cadastrada',
      emptyText: 'Cadastre as categorias de receita e de despesa. Os lançamentos escolhem entre elas.',
      columns: {
        name: 'Nome',
        type: 'Tipo',
        costType: 'Custo sugerido',
        entries: 'Lançamentos',
        rules: 'Regras',
        origin: 'Origem',
        code: 'Código',
        active: 'Situação',
      },
      origin: { system: 'Padrão', user: 'Sua' },
      assetTag: 'fora das despesas operacionais',
      deleteCatalogText: 'É uma categoria do catálogo padrão: excluída, ela não volta. Para guardar o histórico, prefira inativá-la.',
      active: 'Ativa',
      inactive: 'Inativa',
      dialogNew: 'Nova categoria',
      dialogEdit: 'Editar categoria',
      fields: { name: 'Nome', type: 'Tipo', parent: 'Dentro de', defaultCostType: 'Custo sugerido', active: 'Categoria ativa' },
      noParent: 'Nenhuma (categoria principal)',
      typeLocked: 'Já há lançamentos ou subcategorias: o tipo não pode mudar.',
      hint: 'Categorias têm até dois níveis (ex.: Transporte e viagens › Combustível). Categoria inativa não aparece nos novos lançamentos, mas continua nos que já a usam. Mudar uma categoria de lugar muda os relatórios dos lançamentos que já a usam.',
      deleteText: 'A categoria será excluída.',
      deleteUsedText: 'Nenhum lançamento usa esta categoria. | 1 lançamento usa esta categoria. Escolha para onde ele vai. | {count} lançamentos usam esta categoria. Escolha para onde eles vão.',
      moveTo: 'Mover os lançamentos para',
    },
    accounts: {
      emptyTitle: 'Nenhuma conta cadastrada',
      emptyText: 'Cadastre as contas bancárias, o caixa e os cartões. O saldo vem do saldo inicial mais os pagamentos, recebimentos e transferências.',
      columns: { name: 'Nome', type: 'Tipo', bank: 'Banco', openingBalance: 'Saldo inicial', openingDate: 'Em', balance: 'Saldo hoje', entries: 'Movimentos', active: 'Situação' },
      type: { checking: 'Conta corrente', investment: 'Investimento', cash: 'Caixa', credit_card: 'Cartão' },
      active: 'Ativa',
      inactive: 'Inativa',
      openingReview: 'Confirme a data e o saldo inicial',
      openingOn: 'em {date}',
      dialogNew: 'Nova conta',
      dialogEdit: 'Editar conta',
      fields: {
        name: 'Nome',
        type: 'Tipo',
        bank: 'Banco',
        openingBalance: 'Saldo inicial',
        openingDate: 'Data do saldo inicial',
        active: 'Conta ativa',
        closingDay: 'Dia do fechamento',
        dueDay: 'Dia do vencimento',
        creditLimit: 'Limite',
        paymentAccount: 'Conta que costuma pagar',
      },
      cardDaysHint: 'Compra no dia do fechamento entra na fatura que fecha nesse dia; depois dele, na próxima. Mudar os dias não move compras já lançadas.',
      openingHint: 'O saldo inicial é a posição no começo deste dia. Movimentos anteriores não entram no saldo.',
      cardHint: 'O cartão não tem saldo inicial: a posição dele são as faturas.',
      deleteText: 'Só contas que nunca foram usadas podem ser excluídas; as outras são inativadas.',
    },
  },
  suppliers: {
    title: 'Fornecedores',
    subtitle: 'Cadastro simples dos fornecedores, usado nas despesas.',
    new: 'Novo fornecedor',
    searchPlaceholder: 'Nome, e-mail ou CNPJ/CPF',
    statusFilter: 'Situação',
    status: { active: 'Ativo', inactive: 'Inativo' },
    emptyTitle: 'Nenhum fornecedor cadastrado',
    emptyText: 'Cadastre os fornecedores para identificar as despesas.',
    columns: { name: 'Nome', document: 'CNPJ/CPF', email: 'E-mail', phone: 'Telefone', entries: 'Lançamentos', active: 'Situação' },
    dialogNew: 'Novo fornecedor',
    dialogEdit: 'Editar fornecedor',
    fields: { name: 'Nome', document: 'CNPJ ou CPF', email: 'E-mail', phone: 'Telefone', notes: 'Observações', active: 'Fornecedor ativo' },
    deleteText: 'Só fornecedores sem lançamentos podem ser excluídos; os outros são inativados.',
    addressNote: 'Endereço: {address}',
  },
  employees: {
    title: 'Funcionários',
    subtitle: 'Cadastro da equipe, com os dados de RH.',
    new: 'Novo funcionário',
    searchPlaceholder: 'Nome',
    statusFilter: 'Situação',
    status: { active: 'Ativo', inactive: 'Inativo' },
    emptyTitle: 'Nenhum funcionário cadastrado',
    emptyText: 'Cadastre a equipe para acompanhar cargos, contatos e projetos.',
    columns: { name: 'Nome', jobTitle: 'Cargo', email: 'E-mail', phone: 'Telefone', project: 'Projeto', status: 'Situação' },
    dialogNew: 'Novo funcionário',
    dialogEdit: 'Editar funcionário',
    fields: {
      name: 'Nome',
      jobTitle: 'Cargo',
      cpf: 'CPF',
      email: 'E-mail',
      phone: 'Telefone',
      status: 'Situação',
      birthDate: 'Nascimento',
      hireDate: 'Admissão',
      postalCode: 'CEP',
      address: 'Endereço',
      project: 'Projeto',
      responsibilities: 'Responsabilidades',
      access: 'Acesso ao sistema',
      schedule: 'Escala de trabalho',
      scheduleDefault: 'Escala padrão da instituição',
    },
    scheduleHint: 'As horas do timer só contam dentro desta escala.',
    accessHint: 'Os clientes de que este funcionário é consultor ficam na carteira desta pessoa. Vazio: liga pelo e-mail.',
    cepNotFound: 'CEP não encontrado. Preencha o endereço.',
    deleteText: 'Os dados do funcionário serão excluídos.',
  },
  indicators: {
    title: 'Acompanhamento comercial',
    seller: 'Vendedor',
    stage: 'Fase',
    from: 'Período de',
    to: 'Até',
    coverage: 'Cobertura da agenda',
    uncovered: 'Todas as empresas têm próxima atividade | 1 empresa sem próxima atividade | {n} empresas sem próxima atividade',
    onTime: 'Execução no prazo',
    onTimeHint: '{done} de {total} concluídas no prazo no período',
    overdue: 'Atividades atrasadas',
    today: '{n} para hoje',
    stalled: 'Negociações paradas',
    stalledHint: 'Proposta em aberto e mais de {days} dias sem contato',
    awaiting: 'Aguardando retorno',
    awaitingHint: 'Propostas enviadas ainda sem resposta',
    noRecent: 'Clientes sem contato recente',
    noRecentHint: 'Além do prazo da matriz de frequência',
    none: 'Nada por aqui.',
    never: 'nunca contatada',
    daysAgo: 'hoje | há 1 dia | há {n} dias',
    waiting: 'hoje | 1 dia | {n} dias',
  },
  dashboard: {
    title: 'Painel',
    subtitle: 'Resumo do ERP da empresa.',
    cards: {
      customers: 'Clientes',
      customersHint: 'cadastrados',
      projects: 'Projetos',
      projectsHint: 'em andamento · {notStarted} não iniciados',
      proposals: 'Propostas',
      proposalsHint: 'aguardando resposta',
      tickets: 'Chamados',
      ticketsHint: 'abertos ou com a equipe',
      balance: 'Saldo previsto',
      balanceHint: 'no fim de {month}',
    },
    chart: {
      title: 'Fluxo de caixa · próximos 6 meses',
      label: 'Saldo do mês por mês: {summary}',
      open: 'Abrir o financeiro',
    },
    empty: 'Nenhuma área do ERP está disponível para o seu papel.',
    view: {
      label: 'Visão do painel',
      mine: 'Eu',
      team: 'Equipe',
    },
    mine: {
      subtitle: 'O seu dia: agenda, atrasados e pendências.',
      overdue: 'Atrasados',
      overdueHint: 'pendentes de dias anteriores',
      today: 'Hoje',
      todayHint: 'na sua agenda',
      proposals: 'Propostas',
      proposalsHint: 'aguardando resposta',
      tickets: 'Chamados comigo',
      ticketsHint: 'em aberto',
      overdueDues: 'Vencidos',
      overdueDuesHint: 'a receber e a pagar',
      noEmployee: 'Seu login não está ligado a um funcionário.',
      noEmployeeHint: 'Peça a quem administra para ligar o seu acesso em Cadastros › Funcionários.',
    },
    today: {
      title: 'Hoje',
      open: 'Abrir a agenda',
      empty: 'Nada para hoje.',
    },
    overdue: {
      title: 'Atrasados',
      seeAll: 'Ver todos',
      empty: 'Nada atrasado.',
    },
    upcoming: {
      title: 'Próximos 7 dias',
      open: 'Abrir a agenda',
      empty: 'Nada na sua agenda nos próximos 7 dias.',
    },
    projects: {
      title: 'Meus projetos',
      seeAll: 'Ver todos',
      empty: 'Nenhum projeto seu em andamento.',
      openTasks: 'nenhuma tarefa aberta | 1 tarefa aberta | {n} tarefas abertas',
      end: 'Previsão de término',
      noEnd: 'sem previsão',
      progress: 'Progresso',
    },
    portfolio: {
      title: 'Minha carteira',
      seeAll: 'Ver todos',
      empty: 'Nenhum cliente para abordar.',
      lastContact: 'Último contato',
    },
    finance: {
      title: 'Financeiro · 7 dias',
      open: 'Abrir o financeiro',
      income: 'A receber',
      expense: 'A pagar',
      overdueIncome: 'Vencidos a receber',
      overdueExpense: 'Vencidos a pagar',
      empty: 'Nada vence nos próximos 7 dias.',
    },
    week: {
      title: 'Minha semana',
      contacts: 'Contatos registrados',
      proposalsSent: 'Propostas enviadas',
      meetingsRecorded: 'Reuniões registradas',
      activitiesOnTime: 'Atividades no prazo',
      activitiesLate: 'Atividades com atraso',
      onTimeRate: 'Feitas no prazo',
      points: '{n} p.p.',
      lastWeek: 'Semana passada: {value}',
      hint: 'De segunda, {from}, até hoje, comparado com a semana passada inteira.',
    },
    pendingMeetings: {
      title: 'Reuniões a registrar',
      seeAll: 'Ver todas',
      empty: 'Nenhuma reunião sua para registrar.',
    },
    tickets: {
      title: 'Chamados comigo',
      seeAll: 'Ver todos',
      empty: 'Nenhum chamado em aberto com você.',
    },
    byStatus: {
      projects: 'Projetos por status',
      proposals: 'Propostas por status',
      none: 'Nada por aqui ainda.',
      seeAll: 'Ver todos',
      seeAllProposals: 'Ver todas',
    },
    team: {
      title: 'Equipe',
      person: 'Pessoa',
      overdue: 'Atrasados',
      today: 'Hoje',
      pendingMeetings: 'Reuniões a registrar',
      uncovered: 'Sem próxima atividade',
      empty: 'Nenhum funcionário com acesso ao sistema.',
      openAgenda: 'Abrir a agenda de {name}',
      openOverdue: 'Abrir os atrasados de {name}',
      openCustomers: 'Abrir os clientes de {name} sem próxima atividade',
    },
  },
  // Relatórios: since 17/10/2026 only the period fields and "Projetos e tarefas" (the "Visão geral" left).
  // Relatórios › Comissões a fechar (30/10/2026).
  commissions: {
    title: 'Comissões a fechar',
    subtitle: 'Por quem indicou: o que já virou a pagar nas propostas aprovadas e a previsão das propostas ainda em aberto.',
    cards: { toPay: 'A pagar', overdue: 'Vencidas', paid: 'Pagas', forecast: 'Previsão (propostas em aberto)' },
    situations: { label: 'Situação', all: 'Todas', topay: 'A pagar', overdue: 'Vencidas', paid: 'Pagas', forecast: 'Previsão' },
    columns: {
      referrer: 'Quem indicou',
      customer: 'Cliente indicado',
      proposal: 'Proposta',
      due: 'Vencimento',
      amount: 'Comissão',
      open: 'Em aberto',
      status: 'Situação',
    },
    status: { open: 'A pagar', overdue: 'Vencida', settled: 'Paga', forecast: 'Previsão' },
    summary: '1 linha · {value} | {n} linhas · {value}',
    empty: 'Nenhuma comissão por aqui',
    emptyText: 'A comissão nasce quando uma proposta de um cliente indicado é aprovada; as propostas em aberto aparecem como previsão.',
  },
  reports: {
    from: 'De',
    to: 'Até',
    apply: 'Aplicar',
    exportCsv: 'Exportar CSV',
    activity: {
      title: 'Projetos e tarefas',
      subtitle: 'Os projetos em aberto e as tarefas do período, com os acompanhamentos.',
      hint: 'Projetos em aberto (concluídos ficam fora). Tarefas do período: primeiro as que tiveram acompanhamento, depois concluídas, a fazer, em andamento, aguardando retorno e canceladas.',
      customer: 'Cliente',
      allCustomers: 'Todos os clientes',
      none: 'Nenhum projeto em aberto.',
      noTasks: 'Nenhuma tarefa no período.',
      progress: 'Progresso',
      expectedEnd: 'Previsão {date}',
      followedUp: 'Acompanhada',
      completedOn: 'Concluída em {date}',
      cancelledOn: 'Cancelada em {date}',
      due: 'Prazo {date}',
      csvFile: 'projetos_tarefas',
      columns: {
        projectCode: 'Código',
        project: 'Projeto',
        customer: 'Cliente',
        projectStatus: 'Status do projeto',
        progress: 'Progresso (%)',
        task: 'Tarefa',
        status: 'Status',
        priority: 'Prioridade',
        responsible: 'Responsável',
        due: 'Prazo',
        closedOn: 'Concluída/cancelada em',
        followUps: 'Acompanhamentos no período',
      },
    },
  },
  tickets: {
    title: 'Chamados',
    subtitle: 'Bugs, melhorias e dúvidas dos clientes e da equipe.',
    new: 'Novo chamado',
    searchPlaceholder: 'Número ou título',
    filterAll: 'Todos',
    groups: { active: 'Em andamento', customer: 'Com o cliente', closed: 'Encerrados' },
    type: { bug: 'Bug', improvement: 'Melhoria', question: 'Dúvida', other: 'Outro' },
    priority: { low: 'Baixa', medium: 'Média', high: 'Alta', urgent: 'Urgente' },
    status: {
      open: 'Aberto',
      in_progress: 'Em atendimento',
      waiting_customer: 'Aguardando cliente',
      waiting_cost_approval: 'Aguardando aprovação do orçamento',
      cost_negotiation: 'Orçamento em negociação',
      resolved: 'Aguardando aceite',
      closed: 'Fechado',
      closed_no_response: 'Fechado sem resposta',
      cost_refused: 'Orçamento recusado',
      cancelled: 'Cancelado',
    },
    columns: { number: 'Nº', title: 'Título', type: 'Tipo', priority: 'Prioridade', status: 'Status', customer: 'Cliente', responsible: 'Responsável', opened: 'Aberto em' },
    emptyTitle: 'Nenhum chamado',
    emptyText: 'Registre os pedidos de suporte e melhorias para acompanhar até a solução.',
    openedBy: 'Aberto por {name} · {date}',
    openedAt: 'Aberto em {date}',
    noDescription: 'Sem descrição.',
    catalogItem: 'Item do catálogo',
    noCatalogItem: 'Nenhum',
    dialogNew: 'Novo chamado',
    dialogEdit: 'Editar chamado',
    noContact: 'Nenhum contato',
    contactWithoutEmail: 'sem e-mail',
    contactHint: 'Recebe os e-mails do chamado (pedido de resposta, orçamento e aceite).',
    fields: {
      title: 'Título',
      description: 'Descrição',
      type: 'Tipo',
      priority: 'Prioridade',
      status: 'Status',
      customer: 'Cliente',
      contact: 'Contato do cliente',
      project: 'Projeto',
      catalogItem: 'Item do catálogo',
      responsible: 'Responsável',
      sourceTenant: 'Aberto pela instituição',
    },
    deleteText: 'O chamado será excluído.',
    notify: {
      label: 'Avisar o cliente por e-mail',
      registered: 'Manda ao contato a confirmação com o número do chamado.',
      status: 'Manda ao cliente o novo status. A observação fica só para a equipe.',
    },
    detail: {
      heading: 'Chamado',
      back: 'Chamados',
      notFound: 'Chamado não encontrado',
      notFoundText: 'Ele pode ter sido excluído.',
      properties: 'Detalhes',
      changeStatus: 'Mudar status',
      transfer: 'Transferir',
      opened: 'Aberto por',
      statusSince: 'Desde {date}',
      closedHint: 'Chamado encerrado: para alterar, reabra pelo "Mudar status".',
    },
    statusDialog: {
      title: 'Mudar status',
      status: 'Novo status',
      note: 'Observação',
      noteCancel: 'Diga por que o chamado está sendo cancelado.',
      noteReopen: 'Diga por que o chamado está sendo reaberto.',
      noteRefused: 'Diga por que o orçamento foi recusado de vez.',
      noteWithdraw: 'Diga por que o pedido ao cliente está sendo retirado.',
      noteHint: 'Opcional. Fica no histórico.',
      save: 'Mudar status',
    },
    transferDialog: {
      title: 'Transferir chamado',
      to: 'Para',
      reason: 'Motivo',
      reasonHint: 'Fica no histórico. A pessoa é avisada pelo sino.',
      save: 'Transferir',
    },
    history: {
      title: 'Histórico',
      placeholder: 'Novo acompanhamento',
      shortcut: 'Ctrl+Enter registra.',
      external: 'Visível para o cliente',
      externalOff: 'Visível somente para a equipe interna',
      externalHint: 'O cliente vê este acompanhamento na página do chamado e, se você marcar "Avisar o cliente por e-mail", recebe o texto por e-mail. Depois de registrado, não dá para alterar.',
      externalHintOff: 'Fica só no histórico interno: o cliente não vê nem recebe aviso. Use para anotações da equipe, e ligue a opção acima quando for responder ao cliente.',
      add: 'Registrar',
      drop: 'Anexar arquivos (prints, documentos)',
      dropHint: 'Até 8 MB por arquivo.',
      removeFile: 'Tirar {name}',
      tooLarge: 'Arquivo muito grande (limite de 8 MB): {names}',
      internalTag: 'Interno',
      externalTag: 'Visível para o cliente',
      byCustomer: 'Pelo cliente',
      // Done by the customer on their page.
      fromCustomer: {
        created: 'abriu o chamado pela página do cliente',
        customer_replied: 'respondeu',
        quote_decided: { approved: 'aprovou o orçamento', rejected: 'recusou o orçamento' },
        acceptance_decided: { accepted: 'aceitou a entrega', rejected: 'não aceitou a entrega' },
      },
      created: 'abriu o chamado',
      edited: 'alterou {fields}',
      statusChanged: 'mudou o status de {from} para {to}',
      transferred: 'transferiu de {from} para {to}',
      nobody: 'ninguém',
      commented: 'registrou um acompanhamento',
      someone: 'Alguém',
      system: 'Sistema',
      emailTo: 'E-mail enviado para {email}',
      response_requested: 'pediu uma resposta ao cliente',
      customer_replied: 'registrou a resposta do cliente',
      quote_sent: 'enviou o orçamento v{version} para aprovação',
      quote_decided: { approved: 'registrou: o cliente aprovou o orçamento', rejected: 'registrou: o cliente recusou o orçamento' },
      acceptance_requested: 'enviou o chamado para o aceite do cliente',
      acceptance_decided: { accepted: 'registrou: o cliente aceitou a entrega', rejected: 'registrou: o cliente não aceitou a entrega' },
      reminder_sent: 'enviou um lembrete ao cliente',
      auto_closed: 'encerrou o chamado: o cliente não respondeu no prazo',
      auto_accepted: 'considerou a entrega aceita: o cliente não respondeu no prazo',
      fields: {
        title: 'o título',
        description: 'a descrição',
        type: 'o tipo',
        priority: 'a prioridade',
        customerId: 'o cliente',
        projectId: 'o projeto',
        catalogItemId: 'o item do catálogo',
        contactId: 'o contato do cliente',
      },
    },
    customer: {
      title: 'Com o cliente',
      noContact: 'Sem contato do cliente. Escolha em Editar para enviar e-mails.',
      noEmail: 'Contato sem e-mail',
      closesOn: 'Se o cliente não responder até {date}, o chamado fecha sozinho. Um lembrete sai um dia útil antes.',
      acceptedOn: 'Se o cliente não responder até {date}, a entrega é aceita sozinha. Um lembrete sai um dia útil antes.',
      neverBySilence: 'O orçamento nunca é aprovado por falta de resposta: o cliente recebe lembretes até responder.',
      sent: 'E-mail enviado para {email}.',
      optional: 'Opcional.',
      approved: 'Aprovou',
      rejected: 'Recusou',
      accepted: 'Aceitou',
      notAccepted: 'Não aceitou',
      decidedBy: 'Quem respondeu',
      decidedByHint: 'Nome de quem respondeu pelo cliente.',
      note: 'Observação',
      quoteDescription: 'O que será feito',
      quoteAmount: 'Valor',
      quoteDelivery: 'Prazo',
      quoteDeliveryPlaceholder: 'Ex.: 10 dias úteis após a aprovação',
      response: {
        title: 'Pedir resposta',
        intro: 'Vai um e-mail para {name} ({email}). O chamado fica "Aguardando cliente".',
        message: 'O que você precisa saber',
        save: 'Enviar',
      },
      reply: {
        title: 'Registrar resposta do cliente',
        intro: 'O que {name} respondeu (por e-mail, telefone ou WhatsApp). Fica no histórico como resposta do cliente.',
        message: 'Resposta do cliente',
        save: 'Registrar',
      },
      quote: {
        title: 'Enviar orçamento',
        intro: 'Vai um e-mail para {name} ({email}) pedindo a aprovação. O trabalho espera a resposta.',
        message: 'Mensagem',
        save: 'Enviar orçamento',
      },
      quoteDecision: {
        title: 'Registrar decisão do orçamento',
        intro: 'O que {name} respondeu sobre o orçamento.',
        reason: 'Por que recusou',
        save: 'Registrar',
      },
      acceptance: {
        title: 'Enviar para aceite',
        intro: 'Vai um e-mail para {name} ({email}) pedindo a confirmação da entrega.',
        message: 'O que foi feito',
        save: 'Enviar',
      },
      acceptanceDecision: {
        title: 'Registrar aceite',
        intro: 'O que {name} respondeu sobre a entrega.',
        reason: 'O que falta',
        save: 'Registrar',
      },
    },
    quotes: {
      title: 'Orçamentos',
      version: 'v{version}',
      delivery: 'Prazo: {value}',
      note: '“{note}”',
      status: { pending: 'Aguardando', approved: 'Aprovado', rejected: 'Recusado', withdrawn: 'Retirado' },
    },
    settings: {
      title: 'Chamados',
      intro: 'Prazos em dias úteis (com os feriados da empresa). Um lembrete vai ao cliente um dia útil antes do fim do prazo.',
      responseDays: 'Prazo para o cliente responder',
      responseHint: 'Sem resposta, o chamado fecha como "Fechado sem resposta". O orçamento só recebe lembretes nesse intervalo.',
      acceptanceDays: 'Prazo para o aceite da entrega',
      acceptanceHint: 'Sem resposta, a entrega é considerada aceita e o chamado fecha.',
      intake: 'Quem recebe os chamados abertos pelo cliente',
      intakeHint: 'Fica responsável pelos chamados novos da página do cliente e é avisado no sino. Sem ninguém, eles aparecem como "Aberto" na lista.',
      page: 'Página do cliente',
      pageHint: 'Os e-mails dos chamados levam o link de cada um. O cliente também pode entrar por este endereço e pedir o link pelo e-mail cadastrado no contato.',
      pageOff: 'A instituição ainda não tem endereço próprio: os e-mails saem sem o link, e o cliente responde pelo próprio e-mail.',
      copy: 'Copiar',
      copied: 'Endereço copiado.',
    },
  },
}
